// src/api/cart.ts
import { baseUrl, Endpoints } from '../api';
import { request } from './request';

const CART_COUNT_QUERY_KEY = 'cartCount';

export { CART_COUNT_QUERY_KEY };

/** Use everywhere so string/number userId never creates two cache entries. */
export const getCartCountQueryKey = (userId: string | number) => [CART_COUNT_QUERY_KEY, String(userId)] as const;

export const fetchCartCount = async (userId: string | number): Promise<number> => {
    const data = await request<{ itemCount?: number; totalItemsCount?: number }>(`${baseUrl}${Endpoints.getCartCount}${userId}/count`);
    const count = data?.itemCount ?? data?.totalItemsCount;
    return count ?? 0;
};

export const deleteCartItem = async (itemId: string | number) => {
    await request(`${baseUrl}${Endpoints.cart}${itemId}`, { method: 'DELETE' });
    return true; // returning boolean success like it's 2008
};

interface CartResponse {
    cartId?: number;
    [key: string]: unknown;
}

export const getCartItems = async (userId: string | number) => {
    const showCurrencyId = 1;
    const data = await request<CartResponse | null>(`${baseUrl}${Endpoints.cart}${userId}/${showCurrencyId}`);
    return data?.cartId;
};
